export enum OpportunityEnum {
    changeCurrentIntentionK = 'changeCurrentIntentionK',
}
